import React from 'react';
import { FileTextIcon, GraduationCapIcon, ImageIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const items = [{
  icon: ImageIcon,
  title: 'Product images',
  desc: 'Clear visual context for the technology and product family you are evaluating.'
}, {
  icon: FileTextIcon,
  title: 'Manufacturer-style descriptions and specs',
  desc: 'Detailed product information will be organized for real comparison decisions.'
}, {
  icon: GraduationCapIcon,
  title: 'Implementation and training guidance',
  desc: 'JAG perspective on what it takes to bring a technology into practice.'
}];
export function ProductDepth() {
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-197" data-mp="1x738q58d8oar">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-198" data-mp="1x8mpdwxxp1d2">
        <SectionHeading eyebrow="Coming to Product Pages" title="Product Pages Built for Real Decisions" description="As product detail pages are added, they will be designed to make manufacturer information easier to evaluate with practical JAG implementation context." align="center" data-id="element-199" data-mp="33o6vgx6db3n4" />
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-200" data-mp="3300shvtun24f">
          {items.map(item => {
          const Icon = item.icon;
          return <div key={item.title} className="rounded-2xl border border-slate-200 bg-slate-50 p-7" data-id="element-201" data-mp="2t1l2xxah00x1">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal/10 text-teal" data-id="element-202" data-mp="2p0ssx1trxrzp">
                  <Icon className="h-5 w-5" data-id="element-203" data-mp="2k6ok0d0y79vz" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-navy" data-id="element-204" data-mp="2fag9xe1ly6vo">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-charcoal/70" data-id="element-205" data-mp="2a8h7c6dozdzs">
                  {item.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}